import React, { Component } from "react";
import { connect } from "react-redux";
import FormBalance from "../../../components/FormBalance";
import dayjs from "dayjs"
import { loadComptes } from "../../../store/actions/compteAction";
import { loadEcritures } from "../../../store/actions/ecritureAction";
import { Spin } from "antd";

class Balance extends Component {
  componentDidMount() {
    this.props.loadComptes();
    this.props.loadEcritures();
  }

  render() {
    const { comptes, ecritures, report, balance, annee } = this.props;

    return (
      <Spin size="large" tip="Chargement en cours..." spinning={!comptes || !ecritures}>
        {comptes && ecritures && (
          <FormBalance
            comptes={comptes}
            ecritures={
              ecritures &&
              ecritures.sort(
                (a, b) =>
                  dayjs(a.ecriture_date_ecriture, "DD/MM/YYYY").unix() -
                  dayjs(b.ecriture_date_ecriture, "DD/MM/YYYY").unix()
              )
            }
            report={report}
            balance={balance}
            annee={annee}
          />
        )}
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadComptes: () => dispatch(loadComptes()),
    loadEcritures: () => dispatch(loadEcritures()),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    comptes: state.comptes.data,
    ecritures: state.ecritures.data,
    report: state.ecritures.report,
    annee: state.exercice.annee,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Balance);
